var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkout-choice",class:{'disabled-label': _vm.isDisabled}},[_c('BaseRadio',{attrs:{"name":_vm.name,"activeClass":_vm.getRadioClass(),"click":_vm.clickHandler,"ariaLabel":_vm.name || _vm.ariaLabel,"aria-checked":_vm.isActive,"aria-disabled":_vm.isDisabled}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6cf52b4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/CheckoutChoice.vue
// module id = null
// module chunks = 